import React, { useEffect, useState } from "react";
import "./FacultyDevelopment.css"; // Ensure this CSS file exists
import DynamicBanner from "../../include/DynamicBanner";
import StickyNav from "../CommitteeCouncil/Partials/StickyNav";
import api from "../../../../api"; // Your axios instance

// Use environment variable for Base URL
const BASE_URL = process.env.REACT_APP_API_URL;

const FacultyDevelopment = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/faculty-dev");
        if (response.data.status) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Helper to format URLs (appends Base URL if relative path)
  const getFullUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `${BASE_URL}/public${path}`;
  };
  const BannerFullUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `${path}`;
  };

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!data) return <div className="text-center py-5">No Data Found</div>;

  const {
    banner_section,
    introduction_tabs,
    intro_section,
    section_vision,
    section_scope,
    section_member,
    section_program,
  } = data;

  const bannerImage =
    banner_section?.desktop_images?.map((img) => `/${img}`) || [];

  const bannerImageMobile =
    banner_section?.mobile_images?.map((img) => `/${img}`) || [];

  const bannerTitle = banner_section?.heading || "Faculty Development Council";

  return (
    <>
      <DynamicBanner
        title={bannerTitle}
        bgImage={bannerImage}
        bgImageMobile={bannerImageMobile}
      />

      <StickyNav tabs={introduction_tabs || []} />

      <div className="faculty-development-page">
        {/* --- Intro Section --- */}
        {intro_section && (
          <section className="py-5">
            <div className="container">
              <div className="sec-title text-center mb-4">
                <h2>{intro_section.heading}</h2>
              </div>
              <div className="row">
                <p style={{ textAlign: "justify" }}>
                  {intro_section.description}
                </p>
              </div>
            </div>
          </section>
        )}

        {/* --- Vision & Mission Section --- */}
        {section_vision && section_vision.length > 0 && (
          <section className="py-3 facultyDev">
            <div className="container">
              <div className="row g-4 mb-5">
                {section_vision.map((item, index) => {
                  const isVision = item.heading
                    .toLowerCase()
                    .includes("vision");
                  const headerClass = isVision ? "bg-primary" : "bg-success";
                  const iconClass = isVision ? "fa-eye" : "fa-bullseye";

                  return (
                    <div className="col-md-6" key={item.id}>
                      <div className="card h-100 mx-auto w-85 shadow-sm">
                        <div
                          className={`card-header ${headerClass} text-white fw-bold`}
                        >
                          <i className={`fa ${iconClass} me-2`}></i>
                          {item.heading}
                        </div>
                        <div className="card-body">
                          <ul className="list-unstyled">
                            {item.list_points?.map((point, i) => (
                              <li key={i} className="mb-2 d-flex">
                                <i className="fa fa-check text-success me-2 mt-1"></i>
                                <span>{point}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        )}

        {/* --- Scope Section --- */}
        {section_scope && section_scope.length > 0 && (
          <section
            className="pb_80 scope-section text-white py-5"
            style={{ backgroundColor: "#2c3e50" }}
          >
            <div className="container">
              <div className="sec-title text-center mb-5">
                <h2 className="text-white">Scope</h2>
              </div>
              <div className="row justify-content-center align-items-stretch g-4">
                {section_scope.map((scope) => (
                  <div className="col-md-3" key={scope.id}>
                    <div className="scope-box p-4 h-100 border border-light rounded">
                      <h6 className="text-white fw-bold text-center mb-3">
                        {scope.main_heading}
                      </h6>
                      <p className="small text-center">{scope.textarea}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* --- Members Table Section --- */}
        {section_member && section_member.length > 0 && (
          <section className="py-5">
            <div className="container">
              {section_member.map((memSec) => (
                <div key={memSec.id}>
                  <div className="sec-title text-center mb-4">
                    <h2>{memSec.heading}</h2>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered member-table">
                      <thead className="table-light">
                        <tr>
                          {memSec.table?.columns?.map((col, idx) => (
                            <th
                              key={idx}
                              className={idx === 0 ? "text-center" : ""}
                            >
                              {col}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {memSec.table?.rows?.map((row, rIdx) => (
                          <tr key={rIdx}>
                            {row.map((cell, cIdx) => (
                              <td
                                key={cIdx}
                                className={
                                  cIdx === 0 || cIdx === 2 ? "text-center" : ""
                                }
                              >
                                {cell}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* --- FDP Program Section (Videos & Brochure) --- */}
        {section_program &&
          section_program.map((program) => (
            <section className="py-5 bg-light" key={program.id}>
              <div className="container">
                <div className="sec-title text-center mb-4">
                  <h2>{program.main_heading}</h2>
                </div>

                <div className="row mb-4">
                  {program.pdf_file && (
                    <div className="col-12 mb-3">
                      <strong>Click Here: </strong>
                      <a
                        href={getFullUrl(program.pdf_file)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary fw-bold"
                      >
                        {program.pdf_name
                          ? program.pdf_name.replace("Click Here:", "").trim()
                          : "Download Brochure"}
                      </a>
                    </div>
                  )}

                  {program.summernote && (
                    <div
                      className="col-12"
                      style={{ textAlign: "justify" }}
                      dangerouslySetInnerHTML={{ __html: program.summernote }}
                    />
                  )}
                </div>

                {/* Videos Grid - FIXED LOGIC */}
                <div className="row">
                  {program.videos?.map((video, vIdx) => {
                    // If type is 'file', we need the full API URL.
                    // If type is 'url', it's already a YouTube link.
                    const finalVideoUrl =
                      video.type === "file" ? getFullUrl(video.url) : video.url;

                    return (
                      <div className="col-md-3 col-sm-6 col-12 mb-4" key={vIdx}>
                        <a
                          href={finalVideoUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="video-thumbnail d-block position-relative shadow-sm"
                        >
                          <img
                            src={
                              video.thumbnail
                                ? getFullUrl(video.thumbnail)
                                : "/assets/images/default-video.jpg"
                            }
                            alt="Watch Video"
                            className="img-fluid w-100"
                            style={{
                              height: "180px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                          <div className="play-overlay">
                            <img
                              src="/assets/images/youtube-logo-video-player.png"
                              alt="Play"
                              className="play-icon"
                              style={{
                                width: "50px",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            />
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          ))}
      </div>
    </>
  );
};

export default FacultyDevelopment;
